import { t } from '@ankr.com/common';

import { useAuth } from 'modules/auth/hooks/useAuth';

export const useEndpointsPlaceholder = (isMultiChain: boolean) => {
  const { isLoggedIn } = useAuth();

  const hasPlaceholder = !isLoggedIn && isMultiChain;

  if (hasPlaceholder) {
    return t('chain-item.get-started.endpoints.lockedLabelHttps');
  }

  return undefined;
};
